import type { Database } from "../../../../__definitions__/database-definitions";
import { SupabaseService } from "../../../../server/supabase/base-supabase-service";

export type CustomHeader = Database["public"]["Tables"]["custom_email_header"]["Row"];

export class SupabaseCustomEmailHeaderService extends SupabaseService<"custom_email_header"> {
  table = "custom_email_header" as const;
}
